import {
  File,
  FileSpreadsheet,
  FileText,
  FileType as FileTypeIcon,
  Presentation,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { resolveFileType } from '../lib/fileType';
import type { FileType } from '../lib/fileType';

const ICON_BY_TYPE: Record<FileType, LucideIcon> = {
  pdf: FileText,
  word: FileTypeIcon,
  excel: FileSpreadsheet,
  powerpoint: Presentation,
  other: File,
};

type DocumentTypeTagProps = {
  sourceFileName: string | null | undefined;
};

/**
 * Bestandsidentificatie vooraan een documentrij: een icoon per bestandsfamilie
 * plus een klein label met de extensie.
 *
 * Het icoon blijft altijd neutraal gekleurd — de vorm draagt het type, niet de
 * kleur. De badge is bewust lichter en kleiner dan VBadge (tekst op tint-600
 * i.p.v. tint-800, 11px, font-medium), zodat hij niet verward wordt met de
 * statusbadge rechts in dezelfde rij, die dezelfde tinten gebruikt.
 */
export function DocumentTypeTag({ sourceFileName }: DocumentTypeTagProps) {
  const { type, label } = resolveFileType(sourceFileName);
  const Icon = ICON_BY_TYPE[type];

  return (
    <span className="flex shrink-0 items-center gap-2">
      <Icon className="size-5 text-muted-foreground" />
      <span className="inline-flex w-18 justify-center whitespace-nowrap rounded-md bg-neutral-100 px-1.5 py-0.5 text-[11px] font-medium text-neutral-600">
        {label}
      </span>
    </span>
  );
}
